import React from 'react';
import PropTypes from 'prop-types';

/* Glyphs drawn to optically fill a shared 24×24 box */
const icons = {
  bag: (
    <>
      <path d="M7 8h10l-.9 11.2a1.4 1.4 0 0 1-1.4 1.3H9.3a1.4 1.4 0 0 1-1.4-1.3L7 8z" />
      <path d="M9.5 8V6.8a2.5 2.5 0 0 1 5 0V8" />
    </>
  ),
  cart: (
    <>
      <path d="M4 6h1.7l1.35 9.6a1.1 1.1 0 0 0 1.1.95h8.7a1.1 1.1 0 0 0 1.08-.88L20 9H7.2" />
      <circle cx="10" cy="19.25" r="1.15" />
      <circle cx="16.25" cy="19.25" r="1.15" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8.25" r="3.35" />
      <path d="M5.4 19.5c1.45-3.35 3.85-5 6.6-5s5.15 1.65 6.6 5" />
    </>
  ),
  login: (
    <>
      <path d="M10 5h7.5v14H10" />
      <path d="M4.5 12h10" />
      <path d="M11.5 8.5 15.5 12l-4 3.5" />
    </>
  ),
  menu: (
    <>
      <path d="M5 7.5h14" />
      <path d="M5 12h14" />
      <path d="M5 16.5h14" />
    </>
  ),
  back: (
    <>
      <path d="M14.5 5.5 7 12l7.5 6.5" />
      <path d="M7.5 12H20" />
    </>
  ),
  sale: (
    <>
      <circle cx="8.2" cy="8.2" r="1.6" />
      <circle cx="15.8" cy="15.8" r="1.6" />
      <path d="M7 17.5 17.5 7" />
    </>
  ),
  close: (
    <>
      <path d="M6.5 6.5l11 11" />
      <path d="M17.5 6.5l-11 11" />
    </>
  ),
  chevronLeft: (
    <path d="M14.5 5.5 8 12l6.5 6.5" />
  ),
  chevronRight: (
    <path d="M9.5 5.5 16 12l-6.5 6.5" />
  )
};

const Icon = props => {
  const { name, size, color, className, strokeWidth, style, ...rest } = props;
  const paths = icons[name];

  if (!paths) return null;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{
        display: 'block',
        flexShrink: 0,
        width: size,
        height: size,
        ...style
      }}
      aria-hidden="true"
      {...rest}
    >
      {paths}
    </svg>
  );
};

Icon.propTypes = {
  name: PropTypes.oneOf(Object.keys(icons)).isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  strokeWidth: PropTypes.number,
  style: PropTypes.object
};

Icon.defaultProps = {
  size: 22,
  color: 'currentColor',
  className: '',
  strokeWidth: 1.5,
  style: {}
};

export default Icon;
